import { render } from "./AddToWatchList.vue?vue&type=template&id=31b29944&ts=true"
import script from "./AddToWatchList.vue?vue&type=script&lang=ts"
export * from "./AddToWatchList.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__